import { render } from "./Cutouts.vue?vue&type=template&id=45f238b3"
import script from "./Cutouts.vue?vue&type=script&lang=js"
export * from "./Cutouts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__